"use strict";
/*
 * Created on 2. 10. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../../utils");

var Overview_1 = require("../Overview");

var OverviewConverter_1 = require("./OverviewConverter");

var PaginationConverterImpl_1 = require("./PaginationConverterImpl");

var ProjectionConverterImpl_1 = require("./ProjectionConverterImpl");

var SortDefConverterImpl_1 = require("./SortDefConverterImpl");
/**
 * Default implementation of {@link OverviewConverter}.
 *
 * @author Radek Beran
 */


var OverviewConverterImpl =
/*#__PURE__*/
function (_OverviewConverter_1$) {
  _inherits(OverviewConverterImpl, _OverviewConverter_1$);

  function OverviewConverterImpl(filterConverter) {
    var _this;

    _classCallCheck(this, OverviewConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OverviewConverterImpl).call(this));
    _this.filterConverter = filterConverter;
    _this.paginationConverter = new PaginationConverterImpl_1.PaginationConverterImpl();
    _this.projectionConverter = new ProjectionConverterImpl_1.ProjectionConverterImpl();
    _this.sortDefConverter = new SortDefConverterImpl_1.SortDefConverterImpl();
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(OverviewConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      var filter = this.filterConverter.toObject(source.filter, conversions);
      return new Overview_1.Overview(filter, utils_1.Utils.isValueMissing(source.sorting) ? null : conversions.asObjectList(source, 'sorting', function (doc) {
        return _this2.sortDefConverter.toObject(doc, conversions);
      }), utils_1.Utils.isValueMissing(source.projection) ? null : this.projectionConverter.toObject(source.projection, conversions), utils_1.Utils.isValueMissing(source.pagination) ? null : this.paginationConverter.toObject(source.pagination, conversions));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var document = {};
      document = Object.assign(document, {
        filter: this.filterConverter.toDocument(source.filter, conversions),
        sorting: source.sorting !== null ? conversions.asObjectArray(source, 'sorting', function (sortDef) {
          return _this3.sortDefConverter.toDocument(sortDef, conversions);
        }) : null,
        projection: source.projection !== null ? this.projectionConverter.toDocument(source.projection, conversions) : null,
        pagination: source.pagination !== null ? this.paginationConverter.toDocument(source.pagination, conversions) : null
      });
      return document;
    }
  }]);

  return OverviewConverterImpl;
}(OverviewConverter_1.OverviewConverter);

exports.OverviewConverterImpl = OverviewConverterImpl;